// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"wrapper_2LhsQ","inner":"inner_22lX7"};